<template>
  <assistant-step>
    <gc-form class="assistant-form">
      <assistant-header
        title="emobilityBuy.title"
        :onPrev="onPrev"
      ></assistant-header>
      <gc-row>
        <gc-col
          cols="12"
          md="7"
          class="products gc-pt-6 md:gc-pr-6 lg:gc-border-r-2"
        >
          <p class="gc-text-sm">
            {{ $t('emobilityBuy.products.desc') }}
          </p>
          <h3 class="gc-text-2xl">{{ $t('emobilityBuy.products.top') }}</h3>

          <gc-row class="gc-flex gc-px-4 gc-mt-4">
            <gc-col cols="12" class="gc-px-0">
              <WallboxList :assistantContext="assistantContext"></WallboxList>
            </gc-col>
          </gc-row>
          <p class="gc-text-xs gc-px-2">
            {{ $t('emobilityBuy.products.wallboxHint') }}
          </p>
          <gc-button
            class="cta-offer gc-mt-4 gc-px-8 gc-py-6"
            color="primary"
            :href="`${storeUrl}/Elektromobilitaet/Produkte/`"
          >
            <font-awesome-icon class="gc-mr-4" :icon="faArrowRight" />
            <span class="gc-font-normal">
              {{ $t('emobilityBuy.products.button.allProducts') }}</span
            >
          </gc-button>
        </gc-col>
        <gc-col cols="12" md="5" class="gc-py-0 lg:gc-px-6">
          <div class="gc-flex gc-flex-col gc-p-6">
            <h3 class="gc-text-2xl gc-mb-4">
              {{ $t('emobilityBuy.consultation.header') }}
            </h3>
            <p>
              {{ $t('emobilityBuy.consultation.text') }}
            </p>
            <div class="gc-flex gc-items-center gc-gap-4">
              <font-awesome-icon :icon="faPhone" style="color: #ed7100" />
              <span>0214 181-1410</span>
            </div>
            <div class="gc-flex gc-items-center gc-gap-4 gc-mt-4">
              <font-awesome-icon :icon="faEnvelope" style="color: #ed7100" />
              <a href="mailto:elektromobilitaet@stawag.de" class="gc-underline"
                >elektromobilitaet@stawag.de</a
              >
            </div>
          </div>
        </gc-col>
      </gc-row>
    </gc-form>
  </assistant-step>
</template>

<script lang="ts">
import { defineComponent, onMounted } from '@vue/composition-api';
import {
  faArrowLeft,
  faArrowRight,
  faPhone,
  faEnvelope,
} from '@fortawesome/pro-regular-svg-icons';
import AssistantStep from '@/components/AssistantStep.vue';
import AssistantStepNavigation from '@/components/AssistantStepNavigation.vue';
import { stepComponentProps } from '@/lib/steps/helper';
import GcButton from '@/components/primitives/GcButton.vue';
import AssistantHeader from '~/components/AssistantHeader.vue';
import GcForm from '@/components/primitives/GcForm.vue';
import GcCol from '@/components/primitives/GcCol.vue';
import GcRow from '@/components/primitives/GcRow.vue';
import { StepId } from '~/consts/assistant-steps';
import WallboxList from '~/components/wallbox-list/WallboxList.vue';
import { sendEvent } from '@/lib/analytics/dataLayer';

export default defineComponent({
  components: {
    WallboxList,
    GcForm,
    GcRow,
    GcCol,
    GcButton,
    AssistantStep,
    AssistantStepNavigation,
    AssistantHeader,
  },
  props: {
    ...stepComponentProps,
  },
  setup: (props, { emit }) => {
    onMounted(() => {
      /**
       *  Google Tag Manager push dataLayer
       */
      sendEvent({ eventName: 'shop_assistant_open_wallbox' });
    });

    const onPrev = () => {
      emit('transition', {
        event: 'JUMP_TO_' + StepId.EMOBILITY_INTEREST.toUpperCase(),
      });
    };

    const onNext = () => {
      emit('transition', {
        event: 'JUMP_TO_' + StepId.ASSISTANT_SUBMIT.toUpperCase(),
      });
    };

    const storeUrl = process.env.VUE_APP_STAWAG_HOST;

    return {
      onNext,
      onPrev,
      StepId,
      faArrowLeft,
      faArrowRight,
      faPhone,
      faEnvelope,
      storeUrl,
    };
  },
});
</script>
